import React from 'react'
import { Link } from 'react-router-dom'

import { getLoginPath } from '@app/modules/Auth'

import './style.scss'

const UnAuthLogo = () => {
  return <Link to={getLoginPath()} className='un-auth-logo' />
}

export default UnAuthLogo
